import React from "react";

import "../css/footer.css";

function Footer() {
  return (
    <div className="footer container mb-3">
      <hr/>

      <div className="foterFinal text-center">
        <span className="version">Manuales - Beta 0.4</span>&nbsp;
        <span className="brand">&copy;Vidónbar</span>
      </div>
    </div>
  );
}

export default Footer;
